// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import getProp from "@insite/mobius/utilities/getProp";
import { radio as commonRadio } from "@store/Themes/common/styleguide/components/forms";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

const radio: Styleguide["radio"] = {
    ...commonRadio,
    defaultProps: {
        ...commonRadio?.defaultProps,
        css: css<any>`
            ${commonRadio?.defaultProps?.css}
            cursor: pointer;

            input {
                & + label {
                    &::before {
                        height: ${({ _sizeVariant }) => (_sizeVariant === "small" ? 16 : 22)}px;
                        width: ${({ _sizeVariant }) => (_sizeVariant === "small" ? 16 : 22)}px;
                    }
                    &:hover::before {
                        border-color: ${getColor("info")};
                    }
                }

                &:focus + label::before {
                    box-shadow: none;
                    outline-color: ${getProp("theme.focus.color")};
                    outline-style: ${getProp("theme.focus.style")};
                    outline-width: ${pxToRem(1)};
                }

                &:checked:not(:disabled) + label::before {
                    border-color: ${getColor("primary")};
                    background: ${getColor("common.background")};
                }

                &:checked + label::after {
                    content: "";
                    display: block;
                    height: ${({ _sizeVariant }) => (_sizeVariant === "small" ? 6 : 12)}px;
                    width: ${({ _sizeVariant }) => (_sizeVariant === "small" ? 6 : 12)}px;
                    left: ${({ _sizeVariant }) => (_sizeVariant === "small" ? 3 : 5)}px;
                    top: calc(50% - ${({ _sizeVariant }) => (_sizeVariant === "small" ? 3 : 7)}px);
                    background: ${getColor("primary")};
                }

                &:checked:disabled,
                &:disabled {
                    & + label::before {
                        border-color: ${getColor("common.disabled")};
                    }

                    & + label::after {
                        background: ${getColor("common.disabled")};
                    }
                }
            }
        `,
    },
};

export default radio;
